import { memo, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import DashboardContext from "../../Context";
import { useHistory } from "react-router-dom";

// import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { HubConnectionBuilder } from "@microsoft/signalr";
/**
 * این کامپوننت برای نمایش سفارش جدید ویا نیرو مرخصی است
 * برای این کار از سیگنال آر استفاده شده است
 * درصورت کلیک روی مدال به ان صفحه میره و در سایر مروگر ها حذف میشه
 */
const SignalrClient = () => {

    const [connection, setConnection] = useState(null);
    const [selfClick, setSelfClick] = useState(false);
    const [isClickInProgress, setIsClickInProgress] = useState(false);
    const [message, setMessage] = useState({});
    const { authentication, handelerrors, notificationUrl } = useContext(DashboardContext);
    const history = useHistory();

    useEffect(() => {

        if (authentication) {
            const connect = new HubConnectionBuilder()
                .withUrl(`${notificationUrl}/notificationhub`, { accessTokenFactory: () => authentication.split(" ")[1] })
                // .withUrl("http://localhost:53678/notificationhub", { accessTokenFactory: () => authentication.split(" ")[1] })
                .withAutomaticReconnect()
                .build();
            setConnection(connect);
        }

    }, []);

    useEffect(() => {
        if (authentication) {

            if (connection != null && connection.connectionState === "Disconnected") {
                connection
                    .start()

                    .then(() => {
                        connection.on("ReceiveMessage", (message) => {
                            const Data = JSON.parse(message)
                            setMessage(Data)
                        });
                        connection.on("SeenMessage", (id) => {
                            if (selfClick) {
                                history.push('/ExpertTicket');
                                setSelfClick(false);
                                setIsClickInProgress(false);
                                return;
                            } else {
                                const element = document.getElementById(id);
                                if (element) element.remove();
                                setSelfClick(false);
                                setIsClickInProgress(false);
                            }
                        });
                    })
                    .catch((error) => { });
            }
        }

    }, [connection]);

    const lockMessage = async (id, link) => {
        if (isClickInProgress) {
            return;
        }
        setIsClickInProgress(true);
        setSelfClick(true);
        try {
            await connection.send('SeenMessage', id);
            toast.dismiss(id);
            window.location.href = link;
        } catch (error) {
            setIsClickInProgress(false);
            setSelfClick(false);
        }
    };

    if (message.Title) {
        if (message.Key === "Ticket") {
            toast.info(<div className='text-center'
                onClick={() => lockMessage(message.Id, message.TargetUrl)}
            >
                <h4 style={{ color: 'white' }}>{message.Title}</h4>
                <p style={{ color: 'white' }} >{message.Message}</p>
            </div>, {
                position: "bottom-left",
                toastId: message.Id,
                hideProgressBar: false,
                toastId: message.Id,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            });
        }
        if (message.Key === "CancelOrder") {
            toast.error(<div className='text-center'
                onClick={() => lockMessage(message.Id, message.TargetUrl)}
            >
                <h4 style={{ color: 'white' }}>{message.Title}</h4>
                <p style={{ color: 'white' }} >{message.Message}</p>
            </div>, {
                position: "bottom-left",
                toastId: message.Id,
                hideProgressBar: false,
                toastId: message.Id,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            });
        }
        if (message.Key === "UpdateOrder") {
            toast.info(<div className='text-center'
                onClick={() => lockMessage(message.Id, message.TargetUrl)}
            >
                <h4 style={{ color: 'white' }}>{message.Title}</h4>
                <p style={{ color: 'white' }} >{message.Message}</p>
            </div>, {
                position: "bottom-left",
                toastId: message.Id,
                hideProgressBar: false,
                toastId: message.Id,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            });
        }
        if (message.Key === "WorkerBlackList") {
            toast.info(<div className='text-center'
                onClick={() => lockMessage(message.Id, message.TargetUrl)}
            >
                <h4 style={{ color: 'white' }}>{message.Title}</h4>
                <p style={{ color: 'white' }} >{message.Message}</p>
            </div>, {
                position: "bottom-right",
                toastId: message.Id,
                hideProgressBar: false,
                toastId: message.Id,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            });
        }
        else {
            toast.info(<div className='text-center'
                onClick={() => lockMessage(message.Id, message.TargetUrl)}
            >
                <h4 style={{ color: 'white' }}>{message.Title}</h4>
                <p style={{ color: 'white' }} >{message.Message}</p>
            </div>, {
                position: "bottom-left",
                toastId: message.Id,
                hideProgressBar: false,
                toastId: message.Id,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return (
        <>
        </>
    );
}

export default memo(SignalrClient);
